export default __webpack_public_path__ + "images/830d56ba05f7b1e207d14d3c52692f0b.png";